import { useEffect, useState } from "react";
import useTranscript from "../../api/api-hooks/tools/useTranscript";
import AppSpinner from "../../elements/AppSpinner";
import RecordButton from "../Sidebar/QuickNote/QuickNoteRecording/RecordButton";
import AudioRecorder from "../Sidebar/QuickNote/QuickNoteRecording/AudioRecordingUtils";

const Recorder = new AudioRecorder();

interface BrieVoiceInputProps {
  onSuccess: (transcript: string) => void;
}

function ProcessingVoice() {
  return (
    <div
      style={{
        height: 125,
        width: 125,
        borderRadius: "50%",
      }}
      className="d-flex justify-content-center align-items-center bg-primary"
    >
      <AppSpinner
        color="white"
        size="xl"
        style={{ height: 75, width: 75, fontSize: 30 }}
      />
    </div>
  );
}

function BrieVoiceInput({ onSuccess }: BrieVoiceInputProps) {
  const [isRecording, setIsRecording] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { fetchTranscript, cancelTranscript } = useTranscript();

  useEffect(() => {
    onStartRecording();
  }, []);

  return (
    <div className="brie-voice-input d-flex flex-column align-items-center pt-3">
      <h3>
        {isLoading
          ? "Processing..."
          : isRecording
          ? "Listening..."
          : "How can I help you?"}
      </h3>
      <p className="text-capitalize mb-5">
        {isLoading
          ? "Processing what you just said"
          : "Tell brie what do you need to do"}
      </p>
      {!isLoading && (
        <RecordButton
          isRecording={isRecording}
          startRecording={onStartRecording}
          pauseRecording={onFinishRecording}
          disabled={isLoading}
          padding="25px"
        />
      )}
      {isLoading && <ProcessingVoice />}
      {error && <div className="text-danger text-center mt-4">{error}</div>}
    </div>
  );

  function onStartRecording() {
    setError(null);
    Recorder.startRecording({
      setIsRecording,
      onSuccess: (audioBlob) => {
        fetchTranscript({
          audioBlob,
          onTranscriptSuccess: (transcript, fileData) => {
            onSuccess(transcript);
            cancelTranscript({ fileData, confirmation: false });
            setIsLoading(false);
          },
          onError: (fileData) => {
            cancelTranscript({ fileData, confirmation: false });
            setIsLoading(false);
          },
        });
      },
      setError: (error) => {
        setError(error);
        setIsLoading(false);
      },
    });
  }

  function onFinishRecording() {
    setIsRecording(false);
    setIsLoading(true);
    Recorder.finishRecording({});
  }
}

export default BrieVoiceInput;
